// extracted by mini-css-extract-plugin
module.exports = {"layoutBaseCenter":"base-center_layoutBaseCenter_1PbDI"};